import React from 'react';
import styled from 'styled-components';
import { FocusStyles } from '../../styles/FocusStyles';
const StyledZendeskWidget = styled.div `
  border-radius: 1.5rem;
  display: grid;
  grid-gap: 0.125rem;
  grid-template-columns: repeat(${props => props.childrenCount}, 1fr);
  height: 3rem;
  min-width: 3rem;
  overflow: hidden;
  width: max-content;

  button,
  a {
    ${FocusStyles}
  }
`;
const ContentItem = styled.div `
  align-items: center;
  background-color: ${props => props.theme.BrandInfo};
  color: ${props => props.theme.Gray};
  display: flex;
  font-family: ${props => props.theme.fonts.serif};
  font-size: 1rem;
  font-weight: bold;
  justify-content: center;
  padding: 0 0.5rem;

  &:first-child:not(:last-child) {
    padding-left: 1rem;
  }

  &:last-child:not(:first-child) {
    padding-right: 1rem;
  }

  > * {
    appearance: none;
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    align-items: center;
    color: inherit;
    display: grid;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    height: 100%;
    text-decoration: inherit;
  }
`;
export const StyledZendeskContent = styled.span `
  padding: 0 0.5rem;
`;
export const ZendeskWidget = ({ children = null, className = undefined, }) => {
    // exclude `null` and `undefined` in children
    const validChildren = React.Children.toArray(children).filter(Boolean);
    return (React.createElement(StyledZendeskWidget, { className: className, "data-testid": "zendesk-widget", childrenCount: validChildren.length }, validChildren.map((item, index) => (React.createElement(ContentItem, { key: index, "data-testid": "zendesk-widget__item" }, item)))));
};
